import { logWarn, type Maybe } from '@amazon/vinyl-util'
import { ctx } from '../env/playbackContext'
import type { PlayableEntity } from '../gql/playableEntityFrag'
import { advertisementToPlaylistEntry } from './advertisementToPlaylistEntry'
import { audiobookToPlaylistEntry } from './audiobookToPlaylistEntry'
import { interludeToPlaylistEntry } from './interludeToPlaylistEntry'
import type { PlaylistEntry } from './PlaylistController'
import { podcastEpisodeToPlaylistEntry } from './podcastEpisodeToPlaylistEntry'
import { trackToPlaylistEntry } from './trackToPlaylistEntry'

const { target } = ctx('playableEntityToPlaylistEntry')

export function playableEntityToPlaylistEntry(
    element: Maybe<PlayableEntity | { __typename: 'Audiobook' | null }>
): PlaylistEntry | null {
    if (element?.__typename === 'Track') {
        return trackToPlaylistEntry(element)
    } else if (element?.__typename === 'PodcastEpisode') {
        return podcastEpisodeToPlaylistEntry(element)
    } else if (element?.__typename === 'Advertisement') {
        return advertisementToPlaylistEntry(element)
    } else if (element?.__typename === 'Interlude') {
        return interludeToPlaylistEntry(element)
    } else if (element?.__typename === 'Audiobook' && 'playParams' in element) {
        // The cloud-queue node union carries a bare `{ __typename: 'Audiobook' }`
        // (audiobooks are never queued — they play Audible-SDK-only); only the
        // full-fields shape from `audiobookFields` is convertible.
        return audiobookToPlaylistEntry(element)
    } else {
        logWarn(target, 'Unhandled type:', element?.__typename)
        return null
    }
}
